import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';
import { Box, Stack } from '@mui/material';

import FormProvider, { RHFTextField } from '@/commons/hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { Icon } from '@iconify/react';
import { useCashRegisterContext } from '@/hooks/useCashRegisterContext';
import { useTheme } from '@mui/material/styles';
import { closeCashRegisterSchema } from './validations';
import { CashRegister } from '../../types';

type FormValuesProps = CashRegister;

type Props = {
  isEdit?: boolean;
  isLoading?: boolean;
  onSave: (values: any) => void;
};

export default function CashRegisterCloseForm({ isEdit = false, onSave, isLoading }: Props) {
  const { isOpen } = useCashRegisterContext();
  const { palette } = useTheme();

  const methods = useForm<any>({
    defaultValues: {},
    resolver: yupResolver(closeCashRegisterSchema),
  });

  const { reset, handleSubmit, control } = methods;

  const onSubmit = async (data: FormValuesProps) => {
    try {
      await onSave({ ...data });
      reset();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Box sx={{ justifyContent: 'center', display: 'flex', mt: isOpen ? 2 : 0 }}>
        <Icon icon="mdi:cash-off" color={palette.error.main} width={100} />
      </Box>
      <Stack sx={{ px: 3, gap: 2, py: 2 }} style={{ display: 'flex', flexDirection: 'column' }}>
        <RHFTextField
          name="cash"
          label="Efectivo"
          placeholder="Dinero en efectivo"
          control={control}
        />
        <RHFTextField
          name="creditCard"
          label="Datafono"
          placeholder="Dinero en Datafono"
          control={control}
        />
        <RHFTextField
          name="transference"
          label="Tranferencias"
          placeholder="Dinero en Transferencias"
          control={control}
        />
      </Stack>
      <Stack sx={{ px: 3, gap: 2 }} style={{ display: 'flex', flexDirection: 'column' }}>
        <RHFTextField
          name="comment"
          label="Comentarios"
          placeholder="Escribe la razon de cerrar el turno"
          control={control}
        />
      </Stack>
      <Stack sx={{ justifyContent: 'center', my: isOpen ? 2 : 0 }}>
        <LoadingButton type="submit" variant="outlined" loading={isLoading}>
          {!isEdit ? 'Cerrar turno' : 'Save Changes'}
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
